export enum ContentLandingPageAction {
  VIEW = 'view',
  DOWNLOAD = 'download',
}
